<template>
  <v-main>
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col align-self="center" sm="8" md="6" lg="4" xl="4">
          <v-alert type="info" v-if="!validLink">
            <span class="text-h6">確認中...</span>
          </v-alert>
          <v-card v-if="validLink" outlined class="elevation-2 mx-auto pa-10">
            <div class="d-flex justify-center align-center">
              <img :src="logo" alt="Gigalogy Logo" class="logo" />
            </div>
            <v-card-title class="font-weight-bold">
              パスワードをリセット
            </v-card-title>
            <v-card-subtitle>
              パスワード条件：長さは8文字以上、メールアドレスや名前の一部分が含まれない、小文字、大文字、数字、記号のうち少なくとも3つが含まれていること
            </v-card-subtitle>
            <v-card-text>
              <v-form ref="passwordForm">
                <v-text-field
                  v-model="passwordForm.password"
                  prepend-inner-icon="lock"
                  label="新しいパスワード"
                  outlined
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  :rules="[
                    required('新しいパスワード'),
                    password('新しいパスワード'),
                    userInfo?.email ? passwordWithEmail('新しいパスワード', userInfo.email) : () => true,
                    validatePasswordWithName(),
                  ]"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
                <v-text-field
                  ref="repassword"
                  v-model="passwordForm.repassword"
                  prepend-inner-icon="lock"
                  label="パスワードを再入力してください"
                  outlined
                  :append-icon="showRePassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showRePassword ? 'text' : 'password'"
                  :rules="[
                    required('パスワードの再入力'),
                    match(passwordForm.password),
                  ]"
                  @click:append="showRePassword = !showRePassword"
                  class="mt-1"
                ></v-text-field>
                <v-btn
                  color="primary"
                  large
                  block
                  @click="handleSubmitClick"
                  :loading="loading"
                  class="mt-2"
                  >パスワードを変更する</v-btn
                >
              </v-form>
              <v-divider class="my-5"></v-divider>
              <router-link to="/login" class="text-decoration-none">
                ログインに戻る
              </router-link>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  VERIFY_RESET_PASSWORD_LINK,
  RESET_PASSWORD,
  ADD_ALERT,
} from "@/store/_actiontypes";
import validations from "@/helpers/validations";

export default {
  name: "ResetPasswordPage",
  data() {
    return {
      logo: require("@/assets/images/logo_horizontal.png"),
      showPassword: false,
      showRePassword: false,
      passwordForm: {
        password: "",
        repassword: "",
      },
      validLink: false,
      loading: false,
      ...validations,
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.resetPasswordUserDetails,
    }),
  },
  mounted() {
    this.verifyResetPasswordLink();
  },
  watch: {
    "passwordForm.password"() {
      this.$nextTick(() => {
        if (this.passwordForm?.repassword?.length) {
          this.$refs?.repassword?.validate?.();
        }
      });
    },
  },
  methods: {
    ...mapActions("account", [VERIFY_RESET_PASSWORD_LINK, RESET_PASSWORD]),
    ...mapActions("alert", [ADD_ALERT]),
    verifyResetPasswordLink() {
      this.VERIFY_RESET_PASSWORD_LINK({
        token: this.$route?.params?.token,
      })
        .then(res => {
          if (res?.status === 200) {
            this.validLink = true;
            return;
          }
        })
        .catch(error => {
          const message = error?.response?.data?.message || "パスワードリセットリンクが無効または期限切れです。";
          this.$store.dispatch(`alert/${ADD_ALERT}`, {
            message: message,
            color: "error",
          }, { root: true });
          this.$router.push("/404");
        });
    },
    async handleSubmitClick() {
      if (!this.$refs?.passwordForm?.validate()) return;
      this.loading = true;

      const clientIP = await this.$ipCheck?.getClientIP();
      const isAllowed = await this.$ipCheck?.ipRangeCheck(clientIP);

      const executeReset = async (recaptcha_token = null) => {
        const { password } = this.passwordForm;
        const token = this.$route?.params?.token;
        return this.RESET_PASSWORD({ token, password, recaptcha_token, clientIP })
          .catch(err => {
            const message = err?.response?.data?.message || "パスワードのリセットに失敗しました";
            this.ADD_ALERT({ message, color: "error" });
          })
          .finally(() => {
            this.loading = false;
          });
      };

      if (process.env.VUE_APP_CAPTCHA_ENABLED && !isAllowed) {
        this.$recaptcha
          .execute("reset_password")
          .then(recaptcha_token => {
            return executeReset(recaptcha_token);
          })
          .catch(error => {
            console.error("reCaptcha error:", error);
            this.loading = false;
          });
      } else {
        await executeReset();
      }
    },
    validatePasswordWithName() {
      return validations.passwordWithName("パスワード", this.userInfo?.name, "氏名");
    },
  },
};
</script>

<style scoped>
.logo {
  max-height: 55px;
  vertical-align: middle;
}
</style>
